import { EventBus } from "../../../eventbus";
import { userHasAllRights } from "../../../functions/userRights";

export default {
  data() {
    return {
      users: this.$store.state.user,
      company: this.$store.state.company,
      display: "list",
      selectedSpace: null,
      listview: false,
      nospaces: false,
      hidetooltip: false,
    };
  },
  created() {
    // @TODO find a better place to set this.
    localStorage.setItem("tile", JSON.stringify(false));

    EventBus.$on("login", (id) => {
      this.users = this.$store.state.user;
      this.display = "list";
    });
    EventBus.$on("editspace", (id) => {
      this.display = "editspace";
      this.selectedSpace = id;
    });
    EventBus.$on("firstspace", (val) => {
      this.setDisplay(val);
    });
    EventBus.$on("spaceadded", (val) => {
      this.setDisplay(val);
    });
    EventBus.$on("nospaces", (id) => {
      this.nospaces = true;
    });
    EventBus.$on("yesspaces", (id) => {
      this.nospaces = false;
    });
  },
  methods: {
    checkRights(rights) {
      return userHasAllRights(rights, this);
    },
    setDisplay(value) {
      this.display = value;
    },
    hideTooltip() {
      this.hidetooltip = true;
      const formData = new FormData();
      this.$axios.post(baseUrl + "/hidetooltips", formData).then((r) => {
        let user = localStorage.getItem(
          this.$store.state.company + "_" + "user"
        );
        user = JSON.parse(user);
        user.tooltips = 0;
        localStorage.setItem(
          this.$store.state.company + "_" + "user",
          JSON.stringify(user)
        );
        this.$store.state.user = JSON.parse(
          localStorage.getItem(this.$store.state.company + "_" + "user")
        );
        this.users = this.$store.state.user;
      });
    },
  },
};
